export function formatLabels(items) {
    const values = items.map((item) => item.label);

    return values.length > 2
        ? `${values[0]}, ${values[1]} + ${values.length - 2}`
        : values.join(" + ");
}
